export class RespuestaLoginDTO
{
    Mensaje:string;
    valido:number;
    RutCli:number;
    constructor(
        Mensaje:string,
        valido:number,
        RutCli:number
    )
    {
        this.Mensaje=Mensaje;
        this.valido=valido;
        this.RutCli=RutCli;
    }
}

export const RespuestaInicial:RespuestaLoginDTO=
{
    Mensaje:"",
    valido:0,
    RutCli:-1
}